// ----------------------------------------------------------------------
// <copyright file="Izenda.Value.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
/** https://github.com/JedWatson/react-select */

/**
 * Value component of multi selectbox
 */
!(function() {
  var React = require('react');
  var classnames = require('classnames');
  const { isEmpty } = require('lodash/fp');
  var Value = React.createClass({
    propTypes: {
      children: React.PropTypes.node,
      disabled: React.PropTypes.bool, // disabled prop passed to ReactSelect
      onClick: React.PropTypes.func, // method to handle click on value label
      onRemove: React.PropTypes.func, // method to handle removal of the value
      value: React.PropTypes.object.isRequired, // the option object for this value
      tooltip: React.PropTypes.string // tooltip for the value
    },

    getInitialState: function() {
      var tooltip = this.props.tooltip;
      var object = this.props.value;
      var value = object.value;
      var stringValue = !isEmpty(value) ? value : '';

      var defaultValue = !isEmpty(tooltip) ? tooltip : stringValue;

      return {
        tooltip: defaultValue // set default tooltip equal value
      };
    },

    handleMouseDown: function handleMouseDown(event) {
      if (event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (this.props.onClick) {
        event.stopPropagation();
        this.props.onClick(this.props.value, event);
        return;
      }
    },

    onRemove: function onRemove(event) {
      event.preventDefault();
      event.stopPropagation();
      this.props.onRemove(this.props.value);
    },

    renderRemoveIcon: function renderRemoveIcon() {
      if (this.props.disabled || !this.props.onRemove) return;
      return (
        <span className="Select-value-icon" onMouseDown={this.onRemove}>
          &times;
        </span>
      );
    },

    renderLabel: function renderLabel() {
      var className = 'Select-value-label';
      return this.props.onClick || this.props.value.href ? (
        <a
          className={className}
          href={this.props.value.href}
          target={this.props.value.target}
          onMouseDown={this.handleMouseDown}
        >
          {this.props.children}
        </a>
      ) : (
        <span className={className}>{this.props.children}</span>
      );
    },

    render: function() {
      // change the tooltip when choose different item
      var tooltip = this.props.value.optionTooltip;
      !tooltip && (tooltip = isEmpty(this.props.value.value) ? this.props.children : this.props.value.value);

      return (
        <div
          className={classnames('Select-value', this.props.value.className)}
          style={this.props.value.style}
          title={tooltip}
        >
          {this.renderLabel()}
          {this.renderRemoveIcon()}
        </div>
      );
    }
  });

  module.exports = Value;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/multiSelectBox/Izenda.Value.jsx